module.exports = __webpack_public_path__ + "static/media/logo.296965fd.png";